export const accessTemplate = [
  {
    label: '企业基本信息',
    prop: 'basic-info',
    component: 'quality-admission-basicInfo',
    version: 'quality-admission-basicInfo_2_1',
    $component: '资质准入-基本信息',
    $version: 'quality-admission-basicInfo_2_1',
    $index: 0
  },
  {
    label: '地址信息',
    prop: 'fullfield-address',
    component: 'fullfield-address',
    version: 'fullfield-address_2_1',
    $component: '全量供应商地址信息表',
    $version: 'fullfield-address_2_1',
    $index: 1
  },
  {
    label: '银行资料',
    prop: 'fullfield-bank',
    component: 'fullfield-bank',
    version: 'fullfield-bank_2_1',
    $component: '全量供应商银行资料',
    $version: 'fullfield-bank_2_1',
    $index: 2
  },
  {
    label: '认证资料',
    prop: 'fullfield-certificated',
    component: 'fullfield-certificated',
    version: 'fullfield-certificated_2_1',
    $component: '全量供应商认证资料',
    $version: 'fullfield-certificated_2_1',
    $index: 3
  },
  {
    label: '联系人',
    prop: 'fullfield-contacts',
    component: 'fullfield-contacts',
    version: 'fullfield-contacts_2_1',
    $component: '全量供应商联系人',
    $version: 'fullfield-contacts_2_1',
    $index: 4
  },
  {
    label: '资质准入',
    prop: 'fullfield-acess',
    component: 'fullfield-acess',
    version: 'fullfield-acess_2_1',
    $component: '全量供应商资质准入',
    $version: 'fullfield-acess_2_1',
    $index: 5
  }
];
